import {
  show_detail_default
} from "./chunk-IR27FJG7.js";

// src/layouts/show-detail/index.ts
var show_detail_default2 = show_detail_default;

export {
  show_detail_default2 as show_detail_default
};
